export default "__VITE_ASSET__85db9613__"